import { ExportOutlined } from "@ant-design/icons"
import { Button } from "antd"
import React from "react"

export const ExportButton = ( {
	isExportable,
	getExportData,
	showMessage,
} ) => {
	const handleExport = () => {
		const element = document.createElement( "a" )
		const file = new Blob( [ JSON.stringify( getExportData() ) ], { type: "application/json" } )
		element.href = URL.createObjectURL( file )
		element.download = "career-path-skills.json"
		document.body.appendChild( element )
		element.click()
		showMessage( { type: "success", content: "Skills export done." } )
	}

	return (
		<Button
			disabled={ isExportable }
			onClick={ handleExport }
			className={ "list-container-action-button" }
			icon={ <ExportOutlined className={ "icon-position-fix" } /> }
		>
			{ "Export Skills" }
		</Button>
	)
}
